/* Newland Meubles — front-end interactivity
   - Mobile drawer (open/close)
   - Cart drawer (open/close + ajax add/remove/update/count refresh)
   - PDP image gallery (thumb switching)
   - PDP quantity stepper
*/

(function () {
  'use strict';

  // ===== Helpers =====
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // ===== Mobile drawer =====
  (function () {
    var btn = document.getElementById('hamburgerBtn');
    var drawer = document.getElementById('mobileDrawer');
    var overlay = document.getElementById('drawerOverlay');
    if (!btn || !drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Fermer le menu');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('menu-open');
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Ouvrir le menu');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
    }
    function toggle() {
      if (drawer.classList.contains('is-open')) close(); else open();
    }
    btn.addEventListener('click', toggle);
    overlay.addEventListener('click', close);
    $$('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  })();

  // ===== Cart drawer =====
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.classList.add('cart-open');
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.classList.remove('cart-open');
  }

  $$('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  $$('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCart);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
  });

  // ===== Wishlist (favoris) — localStorage, no app =====
  (function () {
    var KEY = 'newland_wishlist';
    var drawer = document.getElementById('wishlistDrawer');
    var overlay = document.getElementById('wishOverlay');

    function read() {
      var raw;
      try { raw = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
      if (!Array.isArray(raw)) return [];
      // keep only rich entries; drop legacy bare-id strings (can't be rendered)
      return raw.filter(function (it) { return it && typeof it === 'object' && it.id != null; });
    }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function has(id) {
      id = String(id);
      return read().some(function (it) { return String(it.id) === id; });
    }
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function updateBadges() {
      var n = read().length;
      $$('.wish-count').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    }

    function refreshButtons() {
      $$('[data-wishlist], .product-fav').forEach(function (btn) {
        var id = btn.getAttribute('data-wish-id');
        if (!id) return;
        var active = has(id);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var span = btn.querySelector('span');
        if (span) span.textContent = active ? 'Sauvegardé' : 'Sauvegarder';
      });
    }

    function render() {
      if (!drawer) return;
      var body = $('.wishlist-drawer-body', drawer);
      if (!body) return;
      var list = read();
      if (!list.length) {
        body.innerHTML =
          '<div class="cart-empty">' +
            '<h4>Aucun favori</h4>' +
            '<p>Parcourez nos collections et enregistrez les pièces qui vous plaisent avec le cœur.</p>' +
          '</div>';
        return;
      }
      body.innerHTML = list.map(function (it) {
        var url = esc(it.url || ('/products/' + (it.handle || '')));
        return '' +
          '<div class="cart-item wishlist-item" data-wish-row="' + esc(it.id) + '">' +
            '<a class="cart-item-img" href="' + url + '">' +
              (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div>' +
              '<div class="cart-item-name">' + esc(it.title) + '</div>' +
              '<a class="wishlist-item-link" href="' + url + '">Voir le produit →</a>' +
            '</div>' +
            '<div class="cart-item-right">' +
              (it.price ? '<div class="cart-item-price">' + esc(it.price) + '</div>' : '') +
              '<button class="cart-item-remove" type="button" data-wish-remove="' + esc(it.id) + '">Retirer</button>' +
            '</div>' +
          '</div>';
      }).join('');
    }

    function toggleFromButton(btn) {
      var id = btn.getAttribute('data-wish-id');
      if (!id) return;
      var list = read();
      var idx = -1;
      for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(id)) { idx = i; break; } }
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push({
          id: id,
          handle: btn.getAttribute('data-wish-handle') || '',
          title: btn.getAttribute('data-wish-title') || '',
          url: btn.getAttribute('data-wish-url') || '',
          image: btn.getAttribute('data-wish-image') || '',
          price: btn.getAttribute('data-wish-price') || ''
        });
      }
      write(list);
      refreshButtons();
      updateBadges();
      render();
    }

    function removeById(id) {
      write(read().filter(function (it) { return String(it.id) !== String(id); }));
      refreshButtons();
      updateBadges();
      render();
    }

    function open() {
      if (!drawer) return;
      render();
      if (typeof closeCart === 'function') closeCart();
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var toggleBtn = e.target.closest('[data-wishlist], .product-fav');
      if (toggleBtn && toggleBtn.getAttribute('data-wish-id')) { e.preventDefault(); toggleFromButton(toggleBtn); return; }
      var rm = e.target.closest('[data-wish-remove]');
      if (rm) { e.preventDefault(); removeById(rm.getAttribute('data-wish-remove')); return; }
      var openBtn = e.target.closest('[data-wishlist-open]');
      if (openBtn) { e.preventDefault(); open(); return; }
      var closeBtn = e.target.closest('[data-wishlist-close]');
      if (closeBtn) { close(); return; } // no preventDefault: lets the foot <a> still navigate
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });

    refreshButtons();
    updateBadges();
  })();

  // ===== In-store pickup preference (session-wide, persisted) =====
  // Checkbox on the PDP. Persists in localStorage so it stays ticked on EVERY product the
  // client views, and flags the cart with an attribute (staff visibility). It does NOT set the
  // checkout delivery method — Shopify picks that at checkout (native "Retrait en magasin").
  (function () {
    var KEY = 'newland_pickup_pref';
    var cb = document.querySelector('[data-pickup-cb]');
    if (!cb) return;
    var note = document.querySelector('[data-pickup-note]');
    function reflect() { if (note) note.hidden = !cb.checked; }
    function setCartAttr(on) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Retrait en magasin (préférence site)': on ? 'Oui — le client souhaite récupérer à Charleroi' : '' } }),
      }).catch(function () {});
    }
    var saved = false;
    try { saved = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (saved) { cb.checked = true; reflect(); setCartAttr(true); }
    cb.addEventListener('change', function () {
      try { localStorage.setItem(KEY, cb.checked ? '1' : '0'); } catch (e) {}
      reflect();
      setCartAttr(cb.checked);
    });
  })();

  function formatMoney(cents) {
    // Cents → €xx,xx
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  function renderCart(cart) {
    var count = cart.item_count || 0;
    $$('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });

    if (!cartDrawer) return;
    var body = $('.cart-drawer-body', cartDrawer);
    var foot = $('.cart-drawer-foot', cartDrawer);
    if (!body) return;

    if (count === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
          '<h4>Votre panier est vide</h4>' +
          '<p>Découvrez nos collections et trouvez la pièce qui vous ressemble.</p>' +
          '<a class="btn btn-primary" href="/collections/all">Explorer la boutique</a>' +
        '</div>';
      if (foot) foot.style.display = 'none';
      return;
    }

    if (foot) foot.style.display = '';

    var html = '';

    // Upsell banner — auto-suggest montage when cart total ≥ threshold
    var upsell = window.NewlandUpsell;
    if (upsell && cart.total_price >= upsell.threshold) {
      var alreadyInCart = cart.items.some(function (i) { return i.variant_id === upsell.variantId; });
      if (!alreadyInCart) {
        html +=
          '<div class="cart-upsell" role="region" aria-label="Suggestion">' +
            '<div class="cart-upsell-icon">🔧</div>' +
            '<div class="cart-upsell-body">' +
              '<strong>' + upsell.title + '</strong>' +
              '<p>Votre commande dépasse 1 000 € — laissez-nous monter vos meubles chez vous, par un professionnel qualifié.</p>' +
            '</div>' +
            '<div class="cart-upsell-cta">' +
              '<span class="cart-upsell-price">+ ' + upsell.priceFormatted + '</span>' +
              '<button type="button" class="cart-upsell-add" data-upsell-add>Ajouter</button>' +
            '</div>' +
          '</div>';
      }
    }

    // Track if we need to silently auto-correct an oversized montage line
    // (legacy data: qty > 1 in a cart from before the flat-fee fix).
    var montageNeedsFix = null;

    cart.items.forEach(function (item) {
      var img = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/, '_200x$1')
        : '';
      var isMontage = upsell && item.variant_id === upsell.variantId;

      if (isMontage && item.quantity > 1) {
        // Schedule an async one-shot correction; the resulting renderCart
        // re-run will see qty=1 and skip this branch.
        montageNeedsFix = item.key;
      }

      html +=
        '<div class="cart-item ' + (isMontage ? 'cart-item-flat' : '') + '" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-item-img">' +
            (img ? '<img src="' + img + '" alt="' + (item.featured_image.alt || item.product_title) + '">' : '') +
          '</a>' +
          '<div>' +
            '<a href="' + item.url + '" class="cart-item-name">' + item.product_title + '</a>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="cart-item-variant">' + item.variant_title + '</div>'
              : '') +
            (isMontage
              ? '<div class="cart-item-flat-label">Forfait — 1 par panier</div>'
              : '<div class="cart-item-qty">' +
                  '<button type="button" data-qty-down>−</button>' +
                  '<input type="number" min="0" value="' + item.quantity + '" data-qty-input>' +
                  '<button type="button" data-qty-up>+</button>' +
                '</div>'
            ) +
          '</div>' +
          '<div class="cart-item-right">' +
            '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button class="cart-item-remove" type="button" data-remove>Retirer</button>' +
          '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    // Silent one-shot fix for legacy carts with montage quantity > 1
    if (montageNeedsFix) {
      setTimeout(function () { changeLine(montageNeedsFix, 1); }, 0);
    }

    // Wire upsell "Ajouter" button (if banner was injected above)
    var upsellAddBtn = $('[data-upsell-add]', body);
    if (upsellAddBtn && upsell) {
      upsellAddBtn.addEventListener('click', function () {
        upsellAddBtn.disabled = true;
        upsellAddBtn.textContent = 'Ajout…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: upsell.variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () { refreshCart(); })
          .catch(function () {
            upsellAddBtn.disabled = false;
            upsellAddBtn.textContent = 'Ajouter';
            alert('Une erreur est survenue. Veuillez réessayer.');
          });
      });
    }

    var totalEl = $('.cart-totals .val', foot);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Bind row controls — guards because the montage (flat-fee) row has no
    // qty stepper, only a remove button.
    $$('.cart-item', body).forEach(function (row) {
      var key = row.getAttribute('data-key');
      var input = $('[data-qty-input]', row);
      var up = $('[data-qty-up]', row);
      var down = $('[data-qty-down]', row);
      var remove = $('[data-remove]', row);
      if (up && input) up.addEventListener('click', function () { changeLine(key, parseInt(input.value, 10) + 1); });
      if (down && input) down.addEventListener('click', function () { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); });
      if (input) input.addEventListener('change', function () { changeLine(key, Math.max(0, parseInt(input.value, 10) || 0)); });
      if (remove) remove.addEventListener('click', function () { changeLine(key, 0); });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  // PDP add-to-cart (ajax) — supports optional upsell via [data-upsell-cb]:checked.
  // The upsell (montage à domicile) is a FLAT FEE — one service per cart total,
  // regardless of how many products. If it's already in the cart, the upsell
  // checkbox is ignored. Quantity is also locked to 1 in the cart drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"][data-ajax]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], .pdp-add');
    // Target the inner <span> when present (v2/v3 buttons have an SVG icon + span);
    // fall back to the button itself for older markup (just text).
    var btnLabel = btn ? (btn.querySelector('span') || btn) : null;
    if (btn) {
      btn.disabled = true;
      btn.dataset.label = btnLabel.textContent;
      btnLabel.textContent = 'Ajout en cours…';
    }

    function restoreBtn(fallback) {
      if (btn) { btn.disabled = false; btnLabel.textContent = btn.dataset.label || fallback; }
    }
    function parseRes(r) {
      return r.json().catch(function () { return null; }).then(function (data) {
        return { ok: r.ok, status: r.status, data: data };
      });
    }
    function onAddSuccess(fallback) {
      if (btn) {
        btnLabel.textContent = 'Ajouté ✓';
        setTimeout(function () { restoreBtn(fallback); }, 1500);
      }
      refreshCart().then(openCart);
    }

    // ===== Composable set: build cart items from ALL picked pieces (+ optional montage) =====
    if (form.matches('[data-composer-form]')) {
      var pieces = [];
      $$('[data-piece]', form).forEach(function (row) {
        var qInput = row.querySelector('[data-piece-qty]');
        var q = Math.max(0, parseInt(qInput && qInput.value, 10) || 0);
        var vid = parseInt(row.getAttribute('data-variant-id'), 10);
        if (q > 0 && vid) pieces.push({ id: vid, quantity: q });
      });
      if (!pieces.length) {
        restoreBtn('Ajouter ma sélection au panier');
        alert('Sélectionnez au moins une pièce pour composer votre ensemble.');
        return;
      }
      var cmpCb = form.querySelector('[data-upsell-cb]:checked');
      var cmpId = cmpCb ? parseInt(cmpCb.getAttribute('data-variant-id'), 10) : null;
      var cmpPre = cmpCb
        ? fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
        : Promise.resolve(null);
      cmpPre
        .then(function (cart) {
          // Montage is a flat fee — add it once, only if not already in the cart.
          if (cmpId && !(cart && cart.items.some(function (i) { return i.variant_id === cmpId; }))) {
            pieces.push({ id: cmpId, quantity: 1 });
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: pieces })
          });
        })
        .then(parseRes)
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.data && (res.data.description || res.data.message)) || ('Ajout impossible (erreur ' + res.status + ')'));
          }
          onAddSuccess('Ajouter ma sélection au panier');
        })
        .catch(function (err) {
          restoreBtn('Ajouter ma sélection au panier');
          alert((err && err.message) || 'Une erreur est survenue. Veuillez réessayer.');
        });
      return;
    }

    var fd = new FormData(form);
    var upsellCb = form.querySelector('[data-upsell-cb]:checked');
    var upsellVariantId = upsellCb ? parseInt(upsellCb.getAttribute('data-variant-id'), 10) : null;

    // Pre-check: if upsell is requested, fetch current cart to see if montage
    // is already in it. If yes, skip adding the upsell (flat fee, 1 per cart).
    var checkPromise = upsellCb
      ? fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      : Promise.resolve(null);

    checkPromise
      .then(function (currentCart) {
        var alreadyInCart = false;
        if (upsellCb && currentCart) {
          alreadyInCart = currentCart.items.some(function (i) { return i.variant_id === upsellVariantId; });
        }

        if (upsellCb && !alreadyInCart) {
          // Multi-add via items API: main variant + upsell variant
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 },
                { id: upsellVariantId, quantity: 1 }
              ]
            })
          });
        } else {
          // Single-item path: either no upsell OR upsell already in cart
          return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        }
      })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (data) {
          return { ok: r.ok, status: r.status, data: data };
        });
      })
      .then(function (res) {
        // /cart/add.js returns 422 (with a description) when the variant can't be added.
        // Surface the real reason instead of silently opening an empty cart.
        if (!res.ok) {
          var reason = (res.data && (res.data.description || res.data.message)) || ('Ajout impossible (erreur ' + res.status + ')');
          throw new Error(reason);
        }
        if (btn) {
          btnLabel.textContent = 'Ajouté ✓';
          setTimeout(function () {
            btn.disabled = false;
            btnLabel.textContent = btn.dataset.label || 'Ajouter au panier';
          }, 1500);
        }
        refreshCart().then(openCart);
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          btnLabel.textContent = btn.dataset.label || 'Ajouter au panier';
        }
        alert((err && err.message) || 'Une erreur est survenue. Veuillez réessayer.');
      });
  });

  // Init cart count on page load
  refreshCart();

  // ===== PDP gallery =====
  // Skip thumbs handled by the media-aware gallery (inline JS in
  // main-product.liquid). Those carry data-slide-target and switch slides
  // (images + video); this legacy handler only swaps a single <img> src.
  $$('.pdp-thumb').forEach(function (thumb) {
    if (thumb.hasAttribute('data-slide-target')) return;
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
      var alt = thumb.querySelector('img').alt;
      var main = $('.pdp-gallery-main img');
      if (main) { main.src = src; main.alt = alt; }
      $$('.pdp-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ===== PDP quantity stepper — headline price + Alma track the selected quantity =====
  // Variant products only: the single .pdp-qty stepper re-multiplies the displayed total
  // and the Alma 3× split by qty. Composer products have NO .pdp-qty (they use .pcr-qty per
  // piece) so pdpUnitCents stays 0 and refreshPdpTotal() is a no-op — their recompute() owns
  // the price. setAlmaBase/formatMoney used below are hoisted declarations defined further down.
  var pdpQtyInput = null, pdpUnitCents = 0;
  function fmtTotal(cents) { // €1.443,00 style, matching the Liquid money filter
    var p = (cents / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  function refreshPdpTotal() {
    if (!pdpUnitCents) return; // composer PDP / unknown unit price → leave the price as rendered
    var qty = Math.max(1, parseInt(pdpQtyInput && pdpQtyInput.value, 10) || 1);
    var total = pdpUnitCents * qty;
    var pEl = $('.pdp-price'), sEl = $('.sticky-price');
    if (pEl) pEl.textContent = fmtTotal(total);
    if (sEl) sEl.textContent = fmtTotal(total);
    setAlmaBase(total); // Alma split follows the running total (+ montage if ticked)
  }
  $$('.pdp-qty').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    pdpQtyInput = input;
    var up = wrap.querySelector('[data-step="up"]');
    var down = wrap.querySelector('[data-step="down"]');
    if (up) up.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; refreshPdpTotal(); });
    if (down) down.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); refreshPdpTotal(); });
    if (input) input.addEventListener('input', refreshPdpTotal);
  });
  // Seed the unit price from the currently-selected variant so qty×price + Alma are correct
  // on the first stepper click (syncVariantId only runs on a variant-option change).
  (function () {
    if (!pdpQtyInput) return;
    var form = $('form[action*="/cart/add"][data-ajax]');
    if (!form) return;
    try {
      var vs = JSON.parse(form.getAttribute('data-variants') || '[]');
      var idInput = form.querySelector('input[name="id"]');
      var cur = idInput && vs.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
      if (cur) pdpUnitCents = cur.price;
    } catch (e) {}
  })();

  // ===== Alma 3× line — live amount = (product/composer base + montage if ticked) / 3 =====
  // Centralised so the composer, the variant picker AND the "montage" checkbox all update it.
  var almaEl = document.querySelector('[data-alma-amount]');
  var almaBaseCents = almaEl ? (parseInt(almaEl.getAttribute('data-alma-base'), 10) || 0) : 0;
  function almaMoney(c) {
    var p = (c / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  function almaMontageCents() {
    var cb = document.querySelector('[data-upsell-cb]');
    var price = (window.NewlandUpsell && window.NewlandUpsell.price) || 0;
    return cb && cb.checked ? price : 0;
  }
  function updateAlma() {
    if (!almaEl) return;
    almaEl.textContent = almaMoney(Math.round((almaBaseCents + almaMontageCents()) / 3));
  }
  function setAlmaBase(c) { almaBaseCents = c; updateAlma(); }
  (function () {
    var mcb = document.querySelector('[data-upsell-cb]');
    if (mcb) mcb.addEventListener('change', updateAlma); // re-split when montage is (un)ticked
    updateAlma();
  })();

  // ===== Judge.me reviews pagination — resilient fallback =====
  // Judge.me hydrates the review widget asynchronously, and on some theme/widget combos its
  // in-place AJAX pagination silently fails from page 2 on (Judge.me's own snippet binds at
  // DOMContentLoaded — too early — and force-reloads). We DELEGATE the click (so it catches
  // links rendered after load), let Judge.me's AJAX try first, and only fall back to a real
  // navigation to the link's href if the review list hasn't changed shortly after — so the
  // smooth pagination is preserved when it works, and never dead when it doesn't.
  (function () {
    var SEL = '.jdgm-paginate__page, .jdgm-paginate a, .jdgm-pagination a';
    var WIDGET = '.jdgm-rev-widg, .jdgm-review-widget, [data-jdgm-widget]';
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var link = e.target.closest(SEL);
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return; // no real URL to navigate to → leave Judge.me alone
      var w = document.querySelector(WIDGET);
      var before = w ? w.innerHTML : null;
      setTimeout(function () {
        var w2 = document.querySelector(WIDGET);
        if (before !== null && w2 && w2.innerHTML === before) {
          // AJAX didn't update the list → navigate (SEO-friendly URL), landing on the reviews
          window.location.href = href.indexOf('#') === -1 ? href + '#avis' : href;
        }
      }, 700);
    });
  })();

  // ===== PDP composer (build-your-set) — per-piece steppers + live total =====
  // Note: composer rows use .pcr-qty (NOT .pdp-qty) so the min-1 stepper above
  // doesn't fight them — pieces can go down to 0.
  $$('[data-composer]').forEach(function (composer) {
    var form = composer.closest('form');
    if (!form) return;
    var rows = $$('[data-piece]', composer);
    var countEl = form.querySelector('[data-composer-count]');
    var totalEl = form.querySelector('[data-composer-total]');
    var addBtn = form.querySelector('[data-composer-add]');
    // Composer piece → gallery: interacting with a piece (name, ±, or the row) jumps
    // the media viewer to that variant's assigned image (matched by media id) — the
    // composer equivalent of a colour swatch on a normal variant PDP. Safe no-op until
    // images are assigned to variants in admin (variant editor → "Add image").
    var pieceMediaMap = {};
    try { pieceMediaMap = JSON.parse(form.getAttribute('data-variant-media') || '{}'); } catch (e) {}
    function showPieceMedia(row) {
      var mid = pieceMediaMap[row.getAttribute('data-variant-id')];
      if (mid && window.NewlandPdpGallery && window.NewlandPdpGallery.showMedia) window.NewlandPdpGallery.showMedia(mid);
    }
    // Headline + sticky price mirror the set total on a composable PDP (Liquid renders
    // the same value on load; this keeps them in sync as the client edits the set).
    var headPriceEl = $('.pdp-price');
    var stickyPriceEl = $('.sticky-price');
    var compareEl = $('.pdp-compare');
    var saveEl = $('.pdp-save');
    var almaAmountEl = $('[data-alma-amount]');
    function fmtMoneyHead(cents) {
      var p = (cents / 100).toFixed(2).split('.');
      return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
    }

    // FR money format to match the PDP prices ("2 678,00 €"), not the €-prefixed cart helper.
    function fmtEuros(cents) {
      var p = (cents / 100).toFixed(2).replace('.', ',').split(',');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + p[1] + ' €';
    }

    function recompute() {
      var cents = 0, compareCents = 0, picked = 0;
      rows.forEach(function (row) {
        var input = row.querySelector('[data-piece-qty]');
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        var max = parseInt(input.getAttribute('max'), 10);
        if (!isNaN(max) && q > max) q = max; // never exceed the real Bauwens stock
        if (String(q) !== input.value) input.value = q;
        var price = parseInt(row.getAttribute('data-price'), 10) || 0;
        var cmp = parseInt(row.getAttribute('data-compare'), 10) || price; // pre-discount price of this piece
        if (cmp < price) cmp = price;
        cents += price * q;
        compareCents += cmp * q;
        picked += q; // total number of pieces (a qty-2 chevet counts as 2), not number of lines
        row.classList.toggle('is-picked', q > 0);
      });
      if (countEl) countEl.textContent = picked + (picked > 1 ? ' pièces' : ' pièce');
      if (totalEl) totalEl.textContent = fmtEuros(cents);
      var headStr = fmtMoneyHead(cents);
      if (headPriceEl) headPriceEl.textContent = headStr;
      if (stickyPriceEl) stickyPriceEl.textContent = headStr;
      // Struck-through original set price — only when the selected pieces are actually discounted.
      if (compareEl) {
        if (compareCents > cents && picked > 0) {
          compareEl.textContent = fmtMoneyHead(compareCents);
          compareEl.style.display = '';
          if (saveEl) {
            saveEl.textContent = '–' + Math.round((compareCents - cents) / compareCents * 100) + '%';
            saveEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      setAlmaBase(cents); // composer total drives the Alma split (+ montage if ticked)
      if (addBtn) addBtn.disabled = picked === 0;
    }

    rows.forEach(function (row) {
      var input = row.querySelector('[data-piece-qty]');
      var up = row.querySelector('[data-step="up"]');
      var down = row.querySelector('[data-step="down"]');
      // Clicking anywhere on the piece (incl. the ± buttons, which bubble up) previews
      // its image in the gallery.
      row.addEventListener('click', function () { showPieceMedia(row); });
      if (up) up.addEventListener('click', function () {
        var max = parseInt(input.getAttribute('max'), 10);
        var nv = (parseInt(input.value, 10) || 0) + 1;
        if (!isNaN(max) && nv > max) nv = max;
        input.value = nv; recompute();
      });
      if (down) down.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); recompute(); });
      if (input) input.addEventListener('input', recompute);
    });
    recompute();
  });

  // ===== Cart PAGE (/cart) — quantity steppers update the line live (AJAX) =====
  // The dedicated cart page (sections/main-cart.liquid) is static HTML; its .cart-item-qty
  // +/− buttons aren't the drawer's, so wire them here. Updates the line price + summary
  // in place; drops the row at qty 0; reloads to show the empty state when the cart empties.
  (function () {
    var page = $('.cart-page');
    if (!page) return;

    function refreshSummary(cart) {
      var sub = $('[data-cart-subtotal]', page);
      var tot = $('[data-cart-total]', page);
      if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
      if (tot) tot.textContent = formatMoney(cart.total_price);
      $$('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
    }

    function changeLine(key, qty, row) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count === 0) { window.location.reload(); return; }
          var line = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) { line = cart.items[i]; break; }
          }
          if (!line) {
            if (row && row.parentNode) row.parentNode.removeChild(row);
          } else if (row) {
            var input = row.querySelector('.cart-item-qty input');
            if (input) input.value = line.quantity;
            var priceEl = row.querySelector('.cart-item-price');
            if (priceEl) priceEl.textContent = formatMoney(line.final_line_price);
          }
          refreshSummary(cart);
        })
        .catch(function () { window.location.reload(); });
    }

    $$('.cart-item', page).forEach(function (row) {
      var key = row.getAttribute('data-key');
      var input = row.querySelector('.cart-item-qty input');
      var up = row.querySelector('.cart-item-qty [data-step="up"]');
      var down = row.querySelector('.cart-item-qty [data-step="down"]');
      if (!key || !input) return;
      if (up) up.addEventListener('click', function () { changeLine(key, (parseInt(input.value, 10) || 0) + 1, row); });
      if (down) down.addEventListener('click', function () { changeLine(key, Math.max(0, (parseInt(input.value, 10) || 0) - 1), row); });
      input.addEventListener('change', function () { changeLine(key, Math.max(0, parseInt(input.value, 10) || 0), row); });
    });
  })();

  // ===== PDP variant picker (option pills) =====
  $$('.pdp-option').forEach(function (option) {
    var pills = $$('.pdp-option-pill', option);
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var input = option.querySelector('input[type=hidden]');
        if (input) input.value = pill.getAttribute('data-value');
        syncVariantId();
      });
    });
  });

  // Refresh the stock indicator (.pdp-stock) for the selected variant — mirrors the
  // Liquid render in main-product.liquid: real qty when tracked, "Plus que N" if low,
  // rupture at 0. Driven by the Bauwens daily sync (inventory_quantity in data-variants).
  // inventory_quantity is NOT in `product.variants | json`, so the form carries a
  // separate data-variant-stock map { variantId: qty | null } (null = untracked).
  var _stockMap = null;
  function stockMap() {
    if (_stockMap) return _stockMap;
    var f = document.querySelector('form[action*="/cart/add"][data-ajax]');
    try { _stockMap = JSON.parse((f && f.getAttribute('data-variant-stock')) || '{}'); }
    catch (e) { _stockMap = {}; }
    return _stockMap;
  }
  function updateStock(v) {
    var box = document.querySelector('.pdp-stock');
    if (!box || !v) return;
    var raw = stockMap()[v.id];          // tracked qty, or null/undefined when untracked
    var tracked = typeof raw === 'number';
    var qty = tracked ? raw : 0;
    var label = box.querySelector('[data-stock-label]');
    var oldCount = box.querySelector('[data-stock-count]'); if (oldCount) oldCount.remove();
    var oldNote = box.querySelector('[data-stock-note]'); if (oldNote) oldNote.remove();
    box.classList.toggle('is-available', !!v.available);
    box.classList.toggle('is-unavailable', !v.available);
    box.classList.toggle('is-low', !!v.available && tracked && qty > 0 && qty <= 5);
    if (!label) return;
    if (!v.available) {
      label.textContent = 'En rupture de stock';
      var note = document.createElement('span'); note.className = 'muted'; note.setAttribute('data-stock-note', '');
      note.textContent = ' — réapprovisionnement en cours'; label.insertAdjacentElement('afterend', note);
    } else if (tracked && qty > 0 && qty <= 5) {
      label.textContent = 'Plus que ' + qty + ' en stock';
    } else if (tracked && qty > 0) {
      label.textContent = 'En stock';
      var c = document.createElement('span'); c.className = 'muted'; c.setAttribute('data-stock-count', '');
      c.textContent = ' · ' + qty + ' disponibles'; label.insertAdjacentElement('afterend', c);
    } else {
      label.textContent = 'En stock';
    }
  }

  function syncVariantId() {
    var form = $('form[action*="/cart/add"][data-ajax]');
    if (!form) return;
    var variantsData = form.getAttribute('data-variants');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData); } catch (e) { return; }
    var selected = $$('.pdp-option input[type=hidden]', form).map(function (i) { return i.value; });
    var match = variants.find(function (v) {
      return JSON.stringify(v.options) === JSON.stringify(selected);
    });
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = $('.pdp-price');
    var compareEl = $('.pdp-compare');
    var addBtn = form.querySelector('.pdp-add');
    if (match && idInput) {
      idInput.value = match.id;
      pdpUnitCents = match.price; // remember the unit price so the qty multiplier stays correct
      refreshPdpTotal();          // updates .pdp-price + .sticky-price + Alma for the current qty
      updateStock(match); // refresh the real stock count for the picked variant
      // Switch the gallery to this variant's image (matched by media id). No-op
      // if the variant has no image assigned, or before the gallery hook exists.
      try {
        var mediaMap = JSON.parse(form.getAttribute('data-variant-media') || '{}');
        var mid = mediaMap[match.id];
        if (mid && window.NewlandPdpGallery && window.NewlandPdpGallery.showMedia) {
          window.NewlandPdpGallery.showMedia(mid);
        }
      } catch (e) {}
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        var addBtnLabel = addBtn.querySelector('span') || addBtn;
        addBtnLabel.textContent = match.available ? 'Ajouter au panier' : 'Indisponible';
      }
    }
  }
})();
